import { Component, OnInit } from '@angular/core';
import {
	AuthService,
	HttpService,
	NotifyService,
	NotificationSeverity,
	TokenService,
} from 'src/app/services';
import { ActivatedRoute } from '@angular/router';
import { GameList, Game } from 'src/app/models/game.interface';
import { environment as env } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Router } from '@angular/router';

@Component({
	selector: 'cm-game-lobby',
	templateUrl: './game-lobby.component.html',
	styleUrls: ['./game-lobby.component.css']
})
export class GameLobbyComponent implements OnInit {
	protected providerId: number = 0;
	protected language: string | null;
	private language$: Subscription | null;
	protected gameList: GameList | null;
	protected languageFolderName: string;
	protected title: any = '';
	protected isProviderDisable: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private http: HttpService,
		private token: TokenService,
		private translate: TranslateService,
		public auth: AuthService,
		protected router: Router
	) {
		this.language = '';
		this.language$ = null;
		this.gameList = null;
		this.languageFolderName = 'EN_US';
	}

	async ngOnInit() {
		this.route.queryParams.subscribe(params => {
			this.providerId = params['providerId'];
		});

		this.language = this.token.getLocalToken(env.TokenKeys.LanguageToken);

		this.language$ = this.translate.onLangChange.subscribe((value: any) => {
			this.language = value.lang;

			if (this.language)
				this.languageFolderName = this.getCapitalUnderscoreLanguageCode(
					this.language
				);
		});

		if (this.language)
			this.languageFolderName = this.getCapitalUnderscoreLanguageCode(
				this.language
			);

		await this.getGameList();
	}

	private getCapitalUnderscoreLanguageCode(locale: string): string {
		return locale
			.split('-')
			.map((part) => part.toUpperCase())
			.join('_');
	}


	protected getGameList() {
		return new Promise(async (resolve) => {
			const payload: any = {
				CurrentCulture: this.language,
				ProviderId: Number(this.providerId),
				GameCategoryId: null,
				Status: true
			};

			this.http
				.post('provider', 'gamelist', payload)
				.subscribe((resp: GameList) => {
					if (resp && resp.Code == 1) {
						this.gameList = resp;

						this.gameList.Records.forEach(record => {
							if (record.GameCode == "0") {
								this.title = record[`Display_${this.languageFolderName}` as keyof Game];
							}
						});

						this.gameList.Records = this.gameList.Records.filter(record => {
							if (record.DisplayCategory) {
								const displayCategoryArr = record.DisplayCategory.split(',');
								return displayCategoryArr.includes('lobby');
							}
							return false; 
						});

						resolve(true);
					} else {
						resolve(false);
					}
				});
		});
	}

	protected getImageSource(model: any): string {
		let imageSource = model?.Img_EN_US;

		if (this.language == 'en-US') {
			imageSource = model?.Img_EN_US;
		}
		else if (this.language == 'id-ID') {
			imageSource = model?.Img_ID_ID;
		}
		else if (this.language == 'jp-JP') {
			imageSource = model?.Img_JP_JP;
		}
		else if (this.language == 'ko-KO') {
			imageSource = model?.Img_KO_KO;
		}
		else if (this.language == 'th-TH') {
			imageSource = model?.Img_TH_TH;
		}
		else if (this.language == 'tw-TW') {
			imageSource = model?.Img_TW_TW;
		}
		else if (this.language == 'vi-VN') {
			imageSource = model?.Img_VI_VN;
		}
		else if (this.language == 'zh-CN') {
			imageSource = model?.Img_ZH_CN;
		}

		return `${env.AdminAPIURL}/uploads/provider_game/${imageSource}`;;
	}

	protected joinGame() {
		if (!this.auth.isAuthenticated()) {
			this.auth.toggleLoginDisplay(!this.auth.isAuthenticated());
			return;
		}
	}

	protected getSupplierDisplayName(game: any): string {
		return game[`Display_${this.languageFolderName}`];
	}

	public enterGame(game: Game) {
		if (!this.auth.isAuthenticated()) 
		{
			this.router.navigate(['/contents/pages/landing-page']);
		} 
		else if(this.auth.isAuthenticated() && !game.IsMaintenance)
		{
			const url = `/#/contents/pages/loading-page?providerCode=${game.ProviderCode}&gameCode=${game.GameCode}`;
			window.open(url, '_blank');
		} 
	}
}
